import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import styles from './SearchBar.module.scss'

export default function SearchBar({ value, onChange, placeholder = tr("Поиск…") }) {
  useInterfaceLanguage();
  return (
    <div className={styles.wrap}>
      <span className={styles.icon}>🔍</span>
      <input
        className={styles.input}
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={tr(placeholder)}
      />
      {tr(value && (
        <button className={styles.clear} onClick={() => onChange('')}>×</button>
      ))}
    </div>
  )
}
